<template>
    <div class="account">
        <div class="account__body">
            <div class="container">
                <div class="row">

                    <div class="col d7 md-12">
                      <div class="account__nav">
                        <div class="account__nav-list flex">
                          <div class="account__nav-item" v-for="(tab, i) in params?.tabs" :key="i">
                            <div
                                :class="['account__nav-item-inner', state.activeTab === i ? 'active' : '', tab?.disabled?'disabled':'']"
                                @click="tab?.disabled?'':tabs.goTo(i)"
                            >{{ tab.title }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="account__header" v-if="params?.breadcrumbs">
                          <breadcrumbs :items="params.breadcrumbs" />
                          <h2 class="account__header-title">{{ params.title }}</h2>
                      </div>
                      <slot name="before" />
                      <a-tabs v-model="state.activeTab" ref="tabs" @change="setTabEvent">
                          <slot/>
                      </a-tabs>

                  </div>
                  <div class="col d5 md-12 account__aside">
                        <div class="account__aside-inner">
                            <slot name="aside" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted, nextTick} from 'vue'
import { ATabs } from '../ui'
import Breadcrumbs from '../main/Breadcrumbs.vue'

export default {
    name: 'Account',
    components: {
        ATabs,
        Breadcrumbs,
    },
    emits:['setTabEvent'],
    props: ['params'],
    setup: (props, ctx) => {

        const state = ref({
            activeTab: 0,
            isMobile: false,
        })

        const tabs = ref(null)

        const setTabEvent = (e)=>{
            ctx.emit('setTabEvent', { index: e.index });
        }


        onMounted(() => {
            if(Array.isArray(props.params?.tabs)) {
                state.value.activeTab = props.params.tabs.findIndex(tab => !tab.disabled);
                for(let index in props.params.tabs) {
                    if(props.params.tabs[index]?.active) {
                        state.value.activeTab = index;
                    }
                }

                if(state.value.activeTab > 0||true) {
                    tabs.value.goTo(state.value.activeTab);
                }
                nextTick(() => {
                    tabs.value.goTo(state.value.activeTab);
                })
            }
        })

        return {
            state,
            setTabEvent,
            tabs,
        }
    },
}
</script>

<style lang="scss" scoped>
    $namespace: '.account';
    .account {
        &__nav {
            @include tablet {
                background: #fff;
                border-bottom: 1px solid var(--c-gray-700);
                margin: 0 -15px;
                padding: 0 15px;
            }
            @include mobile {
                overflow: auto;
                background: transparent;
                border-bottom: none;
            }
            &-item {
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                color: var(--c-gray-100);
                flex: 1000 0 0;
                max-width: 300px;
                position: relative;
                height: 52px;
                white-space: nowrap;
                .disabled {
                  opacity: 0.5;

                }
              .disabled::before {
                display: none!important;
              }
                @include mobile {
                    margin-right: 42%;
                    flex: initial;
                    &:last-child {
                        margin-right: 0;
                        padding-right: 30px;
                    }
                }
                &-inner {
                    padding: 14px 0;
                    position: relative;
                    display: inline-flex;
                    cursor: pointer;

                    &::before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        width: 0%;
                        height: 3px;
                        background: var(--c-primary-200);
                        margin: 0 auto;
                        transition: all .3s ease;
                    }
                    &:hover {
                        &::before {
                            width: 100%;
                        }
                    }
                    &.active {
                        &::before {
                            width: 100%;
                            background: var(--c-primary-100);
                        }
                    }
                }
            }
        }

        &__header {
            display: none;

            @include tablet {
                display: block;
                padding-top: 42px;
                &-title {
                    margin: 14px 0 0 0;
                }
            }
        }

        &__aside {
            display: flex;
            justify-content: flex-end;
            &-inner {
                width: 100%;
                max-width: 446px;

                @include tablet {
                    max-width: initial;
                }
            }
            ::v-deep(.user-description) {
                @include tablet {
                    display: none;
                }
            }
        }


        &__body {
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 52px;
                width: 100%;
                background: #fff;
                border-bottom: 1px solid var(--c-gray-700);

                @include tablet {
                    display: none;
                }
            }
            @include tablet {
                padding: 0 0 24px 0;
                > .container > .row {
                    flex-direction: column-reverse;
                }
            }
        }

    }

    ::v-deep(.account-card) {
        margin-top: -210px;
        position: relative;
        z-index: 10;

        @include tablet {
            margin-top: 0;
        }
    }

    ::v-deep(.a-tab) {
        .user-description {
            display: none;
            @include tablet {
                display: block;
            }
        }
    }
    ::v-deep(.a-tab__inner) {
        padding: 72px 0;

        @include tablet {
            padding: 26px 0;

            h3 {
                margin-bottom: 24px;
            }
        }
    }

    ::v-deep(.user-description) {
        margin-top: 30px;
    }
    ::v-deep(#{$namespace}__body-section) {
        margin-top: 72px;
        &:first-child {
            margin-top: 0;
        }
        @include tablet {
            margin-top: 58px;
        }
    }
    ::v-deep(#{$namespace}__body-section-title) {
        margin-bottom: 24px;
    }
    ::v-deep(#{$namespace}__body-section-title .a-badge) {
        margin-left: 8px;
        font-weight: 600;
    }

</style>

<style lang="scss">
    .account {
        &__body {
            &-section {
                &-title {
                    margin-bottom: 24px;
                    .a-badge-inner {
                        background: var(--c-gray-700);
                    }
                }
            }
        }
    }
</style>